function MappingCtrl($state) {
    'ngInject';
    // ViewModel
    const vm = this;
    vm.isActiveTab = function(states) {
        return states.find(element => {
            return $state.current.name.startsWith(element);
        });
    }
}

export default {
    name: 'MappingCtrl',
    fn: MappingCtrl
};